import { Builder } from "@builder.io/react";
import { Stats1 } from "@/components/Stats";
import { registerMenuGroups, commonInputs } from "./helper";

const statsGroups = [
  {
    name: "Stats Components",
    items: [
      { name: "Stats1" }, 
    ]
  },
];

export const registerStatsComponents = () => {
  registerMenuGroups(statsGroups); 

  // Stats Components
  Builder.registerComponent(Stats1, {
    name: "Stats1",
    friendlyName: "Stats 1",
    noWrap: true,
    inputs: [
      ...commonInputs.baseSettings({
        includeSpacing: true,
        includePageNav: true,
      }),
      ...commonInputs.contentInputs({
        includeTitle: true,
      }),
      {
        name: "statsItems",
        type: "list",
        defaultValue: [
          {
            value: 100,
            label: "Label 1",
          },
          {
            value: 200,
            label: "Label 2",
          },
          {
            value: 300,
            label: "Label 3",
          },
          {
            value: 400,
            label: "Label 4",
          },
          {
            value: 500,
            label: "Label 5",
          },
          {
            value: 600,
            label: "Label 6",
          },
        ],
        subFields: [
          {
            name: "value",
            type: "string",
          },
          {
            name: "label",
            type: "richText",
          },
        ],
      },
    ],
  });
};
